import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { text: String };

  async copy(event) {
    event.preventDefault();
    if (!this.textValue) return;

    try {
      await navigator.clipboard.writeText(this.textValue);
      this.toast(`Copied: ${this.textValue}`);
    } catch (_error) {
      window.prompt("Copy text", this.textValue);
    }
  }

  toast(message) {
    const toast = document.createElement("div");
    toast.style.position = "fixed";
    toast.style.bottom = "20px";
    toast.style.right = "20px";
    toast.style.padding = "10px 15px";
    toast.style.background = "#333";
    toast.style.color = "#fff";
    toast.style.borderRadius = "8px";
    toast.style.boxShadow = "0 2px 5px rgba(0,0,0,0.5)";
    toast.style.zIndex = "1000";
    toast.textContent = message;
    document.body.appendChild(toast);
    window.SiteNotices.show(toast, { remove: true });
  }
}
